<template>
  <van-popup v-model="show" get-container="body" :style="inLineStyle">
    <div class="header">
        <slot name="header"></slot>
    </div>
    <div class="content">
        <slot name="content"></slot>
    </div>
    <div class="footer">
        <slot name="footer" class="footer"></slot>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    inLineStyle: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (max-width: 1280px){
  .dialog{
    width: 89%;
  }
}
@media screen and (min-width: 1280px){
  .dialog{
    width: 570px !important;
  }
}
.content{
    height: 100%;
}
.footer{
    background-color: #fff;
    width: 100%;
    position: absolute;
    bottom: 0;
}
</style>
